/* global axios 
app\javascript\dashboard\api\reports.js
*/
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getSummary(since, until, type = 'account', id, groupBy, businessHours) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // Barato: diz se o summary/gráficos vão contar na hora (lento), antes deles.
  getRollupCoverage({ from, to, type = 'account', id }) {
    return axios.get(`${this.url}/rollup_coverage`, {
      params: {
        since: from,
        until: to,
        type,
        id,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getConversationMetric(type = 'account', page = 1) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        type,
        page,
      },
    });
  }

  getAgentReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/agents`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getConversationTrafficCSV({ daysBefore = 6 } = {}) {
    return axios.get(`${this.url}/conversation_traffic`, {
      params: { timezone_offset: getTimeOffset(), days_before: daysBefore },
    });
  }

  getLabelReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/labels`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getInboxReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/inboxes`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getTeamReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/teams`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getBotMetrics({ from, to } = {}) {
    return axios.get(`${this.url}/bot_metrics`, {
      params: { since: from, until: to },
    });
  }

  getBotMetricsCoverage({ from, to } = {}) {
    return axios.get(`${this.url}/bot_metrics_coverage`, {
      params: { since: from, until: to },
    });
  }

  getBotSummary({ from, to, groupBy, businessHours } = {}) {
    return axios.get(`${this.url}/bot_summary`, {
      params: {
        since: from,
        until: to,
        type: 'account',
        group_by: groupBy,
        business_hours: businessHours,
      },
    });
  }

  // Nova função para buscar dashboards personalizados do Metabase
  getCustomDashboards() {

    return axios.get(`${this.url}/custom_dashboards`);

  }

    /**
   * Get Round Robin report data
   */
  getRoundRobinReport({ from, to, teamId, inboxId, agentIds } = {}) {
    return axios.get(`${this.url}/round_robin`, {
      params: {
        since: from,
        until: to,
        team_id: teamId,
        inbox_id: inboxId,
        agent_ids: agentIds,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  /**
   * Export Round Robin report as CSV
   */
  exportRoundRobinReport({ from, to, teamId, inboxId, agentIds } = {}) {
    return axios.get(`${this.url}/round_robin/export`, {
      params: {
        since: from,
        until: to,
        team_id: teamId,
        inbox_id: inboxId,
        agent_ids: agentIds,
        timezone_offset: getTimeOffset(),
      },
      responseType: 'blob',
    });
  }

  /**
   * Get agent status history (online/offline)
   * @param {Object} params - Query parameters
   * @param {number} params.accountId - Account ID
   * @param {Array<number>} params.agentIds - Array of agent IDs
   * @param {number} params.limit - Maximum number of history items (default: 50)
   * @param {number} params.teamId - Team ID to filter (optional)
   * @returns {Promise} Axios response with agent status history
   */
  getAgentStatusHistory({ accountId, agentIds, limit = 50, teamId = null } = {}) {
    return axios.get(`${this.url}/agent_status_history`, {
      params: {
        agent_ids: agentIds.join(','),
        limit,
        team_id: teamId,
      },
    });
  }


}

export default new ReportsAPI();
